export enum UserRole {
  CURATOR = 'CURATOR',
  ADMIN = 'ADMIN',
}
